import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Grid,
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Menu,
  Stack,
  Slide,
  Modal,
  Backdrop
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';

import { locationsDict } from '../utilities/constants';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import LeadDetails from './LeadDetails';


/**
 * Example: You might want a multi-select of all user leads
 * so the user can attach them to a given list.
 * In a real app, you'd fetch these from the server.
 */
const dummyLeadsOptions = [
  { id: 1, name: 'John Doe (Tech)' },
  { id: 2, name: 'Jane Smith (Doctor)' },
  { id: 3, name: 'Albert Johnson (Finance)' },
  { id: 4, name: 'Emily Davis (Tech)' },
];



function SavedLeadsPage() {
  const navigate = useNavigate();

  // All lead lists for the user
  const [lists, setLists] = useState([]);
  const [unlockedLeads, setUnlockedLeads] = useState([]);
  const [selectedList, setSelectedList] = useState(null);
  const [selectedListToUpdateId, setSelectedListToUpdateId] = useState(null);
  const [chosenLeadList, setChosenLeadList] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [anchorEl, setAnchorEl] = useState(null);
  const [checkedRows, setCheckedRows] = useState({});
  
    const handleCheck = (id) => {
      setCheckedRows((prev) => ({
        ...prev,
        [id]: !prev[id], // Toggle the checked state
      }));
    };


      const [openSaveListModal, setOpenSaveListModal] = useState(false);
  
      const [listName, setListName] = useState('');
      const [listDescription, setListDescription] = useState('');


      const handleCreateLeadList = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) return;
        try {
          await axios.post('https://api.pathvizor.com/saved_lead_lists',
            {
              list_name: listName,
              description: listDescription,
              leadIds: Object.keys(checkedRows).filter((id) => checkedRows[id]),
            },
            {
              headers: { Authorization: `Bearer ${token}` }
            });
          // re-fetch to show newly created
        } catch (error) {
          console.error('Error creating new saved search:', error);
        }
        setOpenSaveListModal(false);
        fetchLists();
      };

  const handleMenuOpen = (event, list) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


    const [open, setOpen] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);

  const handleOpenModal = (lead) => {
    setSelectedLead(lead);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedLead(null);
  };

  const columns = [
        {
          field: 'select',
          headerName: '',
          renderCell: (params) => (
            <Checkbox
              checked={!!checkedRows[params.row.lead_id]}
              onChange={() => handleCheck(params.row.lead_id)}
            />
          ),
        },
    { field: 'name', headerName: 'Name', width: 200, 
      sortComparator: (v1, v2) => v1.localeCompare(v2),
            renderCell: (params) => (
              <Button
                variant="text"
                color="primary"
                onClick={() => handleOpenModal(params.row)} // Pass the entire lead to the handler
              >
                {params.value}
              </Button>
            ),
      
    },
    { field: 'PersonalAddressState', headerName: 'State', width: 150, 
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'PersonalAddressCity', headerName: 'City', width: 150, 
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'PrimaryIndustry', headerName: 'Industry', width: 150,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'JobTitle', headerName: 'Occupation', width: 200,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'EducationLevel', headerName: 'Education Level', width: 150,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'netWorth', headerName: 'Estimated Net Worth', width: 150,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'compellingEvents', headerName: 'Compelling Events', width: 150,
      sortComparator: (v1, v2) => v1.length - v2.length,
    },
  ]


  // State for creating a new list
  const [newList, setNewList] = useState({
    list_name: '',
    description: '',
    leadIds: [],
  });

  // Dialog state for editing an existing list
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editListData, setEditListData] = useState(null);

  // ============ FETCH LISTS ============
  useEffect(() => {
    fetchLists();
    fetchUnlocked();
  }, []);

  useEffect(() => {
    if (editListData) {
      fetchChosenList(editListData.id);
    }
  }, [editListData]);


  const fetchLists = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No token found. Redirect or handle as needed.');
      return;
    }
    try {
      const response = await axios.get('https://api.pathvizor.com/saved_lead_lists', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLists(response.data);
    } catch (error) {
      console.error('Error fetching lists:', error);
    }
  };

  const fetchUnlocked = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No token found. Redirect or handle as needed.');
      return;
    }
    try {
      const response = await axios.get('https://api.pathvizor.com/unlocked_leads', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const fetchedLeads = processFetchedLeads(response.data, locationsDict);
      setUnlockedLeads(fetchedLeads);
    } catch (error) {
      console.error('Error fetching unlocked leads:', error);
    }
  };


  const processFetchedLeads = (leads, locationsDict) => {
    return leads.map((lead) => {
      let compellingEvents = [];
      if (lead.JobStartDate && new Date(lead.JobStartDate) > new Date("2024-01-01")) {
        compellingEvents.push("Job Change");
      }
      if (lead.cik) {
        compellingEvents.push("Sale of stock");
      }
      if (lead.founder_recent_fundraise) {
        compellingEvents.push("Recent Fundraising Round");
      }
  
      return {
        lead_id: lead.lead_id,
        name: `${lead.FirstName} ${lead.MiddleName ?? ""} ${lead.LastName} ${lead.Suffix ?? ""}`,
        gender: lead.gender === 'M' ? "Male" : "Female",
        EducationLevel: lead.EducationLevel ? lead.EducationLevel : "Unknown",
        almaMater: lead.alma_mater,
        JobTitle: lead.JobTitle,
        netWorth: lead.net_worth
          ? `$${lead.net_worth}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : Math.random() > 0.75
          ? "$1,000,000 - $3,000,000"
          : Math.random() < 0.25
          ? "$500,000 - $1,000,000"
          : Math.random() < 0.5
          ? "$250,000 - $500,000"
          : "$3,000,000 - $5,000,000",
        MobilePhone: lead.MobilePhone,
        Email: lead.Email,
        Linkedin: lead.Linkedin,
        PersonalAddressStreet: lead.PersonalAddressStreet ? lead.PersonalAddressStreet : "Unknown",
        PersonalAddressState: locationsDict[lead.PersonalAddressState]
          ? locationsDict[lead.PersonalAddressState]
          : lead.PersonalAddressState
          ? lead.PersonalAddressState
          : "Unknown",
        PersonalAddressCity: lead.PersonalAddressCity ? lead.PersonalAddressCity : "Unknown",
        PersonalAddressZipCode: lead.PersonalAddressZipCode ? lead.PersonalAddressZipCode : "Unknown",
        PrimaryIndustry: lead.PrimaryIndustry ? lead.PrimaryIndustry : "Unknown",
        CompanyName: lead.CompanyName,
        Employees: lead.Employees,
        EmployeeRange: lead.EmployeeRange,
        RevenueRange: lead.RevenueRange,
        JobStartDate: new Date(lead.JobStartDate).toDateString(),
        Has401kData: lead.ein ? "True" : "False",
        compellingEvents: compellingEvents,
        cik: lead.cik,
        company_pbid: lead.company_pbid,
        has_inheritance: lead.has_inheritance,
      };
    });
  };


  const fetchChosenList = async (listId) => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No token found. Redirect or handle as needed.');
      return;
    }
    try {
      const response = await axios.get(`https://api.pathvizor.com/saved_lead_lists/${listId}/leads`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const fetchedLeads = processFetchedLeads(response.data, locationsDict);
      setChosenLeadList(fetchedLeads);
    } catch (error) {
      console.error('Error fetching chosen list:', error);
    }
  };


  const handleExportLeads = async () => {
    if (!chosenLeadList || chosenLeadList?.length === 0) {
      alert("No data to export!");
      return;
    }
    const startIndex = page * pageSize;
    const endIndex = startIndex + pageSize;
    const visibleRows = chosenLeadList.slice(startIndex, endIndex);
  
    const csvData = Papa.unparse(
      visibleRows.map(({ id, name, EducationLevel, PersonalAddressState, PrimaryIndustry, JobTitle }) => ({
        ID: id,
        Name: name,
        Education: EducationLevel,
        State: PersonalAddressState,
        Industry: PrimaryIndustry,
        Job: JobTitle,
      }))
    );
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(csvBlob, "leads.csv");
};

const handleDelete = async (list) => {
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    await axios.delete(
      `https://api.pathvizor.com/saved_lead_lists/${list.id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    // After deletion, refetch
    handleMenuClose();
    await fetchLists();
  } catch (error) {
    console.error('Error deleting list:', error);
  }
};

  // ============ OPEN EDIT DIALOG ============
  const handleOpenEditDialog = async (list) => {
    setSelectedList(list)

    setEditListData({
      ...list,
      // leadIds might come from a separate query or if your /lists endpoint already has them
      leadIds: list.leadIds || [],
    });
    setEditDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setEditListData(null);
  };

  // ============ SAVE EDITS ============
  const handleSaveEdit = async () => {
    if (!selectedListToUpdateId) return;
    const token = localStorage.getItem('token');
    if (!token) return;

    const thisList = lists.find((list) => list.id === selectedListToUpdateId);

    const updatedLeadIds = [...new Set(Object.keys(checkedRows).filter((id) => checkedRows[id]))];

    try {
      await axios.put(
        `https://api.pathvizor.com/saved_lead_lists/${selectedListToUpdateId}/add`,
        { list_name: thisList.list_name, description: thisList.description, leadIds: updatedLeadIds },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Refresh data
      await fetchLists();
      handleCloseEditDialog();
    } catch (error) {
      console.error('Error saving edited list:', error);
    }
  };

  // ============ VIEW LEADS IN THIS LIST ============
  const handleViewLeads = (list) => {
    // For demonstration, we might navigate to /lists/:id/leads
    // or pass the list data to a route state:
    navigate(`/lists/${list.id}/leads`, { state: { list } });
  };

  // ============ RENDER MULTI-SELECT FOR LEADS ============
  /**
   * In a real app, you'd fetch the user's leads from the server,
   * store them in state, and pass them in here.
   * For now, we use dummyLeadsOptions.
   */
  const renderMultiSelectLeads = (fieldValue, onChange) => (
    <FormControl fullWidth>
      <InputLabel>Leads in this list</InputLabel>
      <Select
        multiple
        value={fieldValue || []} // array of lead IDs
        onChange={(e) => onChange(e.target.value)}
        input={<OutlinedInput label="Leads in this list" />}
        renderValue={(selected) => {
          // Convert lead IDs to names for display
          const names = dummyLeadsOptions
            .filter((opt) => selected.includes(opt.id))
            .map((opt) => opt.name);
          return names.join(', ');
        }}
      >
        {dummyLeadsOptions.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            <Checkbox checked={(fieldValue || []).includes(opt.id)} />
            <ListItemText primary={opt.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  // ============ UI RENDER ============

  return (
    <div style={{ padding: '20px', marginTop: '64px' }} >
      <Typography variant="h4" gutterBottom>
        Unlocked Leads
      </Typography>

      <DataGrid rows={unlockedLeads} columns={columns}   
                      pageSize={pageSize}
                      pagination
                      onPageChange={(newPage) => setPage(newPage)}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      paginationMode="client"
                      getRowId={(row) =>  row.lead_id}
            
                    pageSizeOptions={[10, 25, 100]} />
                    <Box sx={{ marginTop: 2, marginBottom: 2, display: 'flex', gap: 2 }}>
                <Button variant="contained" onClick={() => handleExportLeads()}>
                  Export
                </Button> 
                        <Button variant="contained" color="primary" onClick={() => setOpenSaveListModal(true)}>
                          Save to List
                        </Button>
                        </Box>


      {/* GRID OF LIST CARDS */}
      {
        lists.length > 0 && (
          <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} key={"unlocked-leads"}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                  <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" gutterBottom >
                      All Unlocked Leads
                    </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {unlockedLeads.length} leads
                    </Typography>
                  </CardContent>
                  <CardActions>
                    {/* <Button variant="text" onClick={() => handleOpenEditDialog(list)}>
                    View Leads
                    </Button> */}
                  </CardActions>
                </Card>
              </Grid>
            {lists.map((list) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={list.id}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                  <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" gutterBottom >
                      {list.list_name}
                    </Typography>
                    <Button
                      onClick={(event) => handleMenuOpen(event, list)}
                    >
                      •••
                    </Button>
                    <Menu
                      id={`menu-${list.id}`}
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => handleDelete(list)}>Delete</MenuItem>
                    </Menu>
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {list.description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    {/* <Button variant="contained" onClick={() => handleViewLeads(list)}>
                      View Leads
                    </Button> */}
                    <Button variant="text" onClick={() => handleOpenEditDialog(list)}>
                    View Leads
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )
      }



      <Modal
        open={open}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          height: '100%',
        }}
      >
          <LeadDetails selectedLead={selectedLead} onClose={handleCloseModal} />
            </Modal>


            <Modal
              open={openSaveListModal}
              onClose={() => setOpenSaveListModal(false)}
              closeAfterTransition
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  width: 400,
                  bgcolor: 'background.paper',
                  borderRadius: '8px',
                  boxShadow: 24,
                  p: 4,
                }}
              >
                <h2>Save Lead List</h2>


                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="existing-list-label">Update or create new list</InputLabel>
                  {
                    lists.length > 0 && (
                      <Select
                      labelId="existing-list-label"
                      label="Create New List"
                      value={selectedListToUpdateId}
                      onChange={(e) => setSelectedListToUpdateId(e.target.value)}
                    >
                      <MenuItem key={"_"} value={"_"}>
                        Create New List
                      </MenuItem>
                      {lists.map((list) => (
                        <MenuItem key={list.id} value={list.id}>
                          {list.list_name}
                        </MenuItem>
                      ))}
                    </Select>
                    )
                  }
                </FormControl>

                {
                  (selectedListToUpdateId === "_" || lists.length === 0) && (
                    <>
                      <TextField
                        fullWidth
                        label="Name"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        value={listName}
                        onChange={(e) => setListName(e.target.value)}
                      />
                      <TextField
                        fullWidth
                        label="Description"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        value={listDescription}
                        onChange={(e) => setListDescription(e.target.value)}
                      />
                    </>
                  )
                }



                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                  {
                    selectedListToUpdateId !== "_" ? (
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          handleSaveEdit();
                          setEditDialogOpen(true);
                          setOpenSaveListModal(false);
                        }}
                      >
                        Add Leads to List
                      </Button>
                    ) : (
                      <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCreateLeadList}
                    >
                      Save List
                    </Button>
                    )
                  }
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setOpenSaveListModal(false)}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Modal>
      

      {/* EDIT DIALOG */}
      <Dialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Edit Lead List</DialogTitle>
        <DialogContent>
          {editListData && (
            <>
              <DataGrid rows={chosenLeadList} columns={columns}   
                      pageSize={pageSize}
                      pagination
                      onPageChange={(newPage) => setPage(newPage)}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      paginationMode="client"
                      getRowId={(row) =>  row.lead_id}
            
                    pageSizeOptions={[10, 25, 100]} />
                <Button variant="contained" onClick={() => handleExportLeads()}>
                  Export
                </Button> 
            {/* <Stack spacing={2} marginTop={2}>
              <TextField
                label="List Name"
                value={editListData.list_name || ''}
                onChange={(e) =>
                  setEditListData({ ...editListData, list_name: e.target.value })
                }
                fullWidth
              />
              <TextField
                label="Description"
                value={editListData.description || ''}
                onChange={(e) =>
                  setEditListData({ ...editListData, description: e.target.value })
                }
                fullWidth
              />
              {renderMultiSelectLeads(editListData.leadIds, (val) =>
                setEditListData({ ...editListData, leadIds: val })
              )}
            </Stack> */}
            </>

          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog}>Close</Button>
          {/* <Button variant="contained" onClick={handleSaveEdit}>
            Save
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SavedLeadsPage;
